import { styled } from "@mui/material";

const IconContainer = styled("div")`
  margin-top: 2px;
`;

export { IconContainer };
